import _ from 'lodash';

const assemble = (siteDesignation) => {
  return {
    hq: siteDesignation.plugins.hq,
    locality: siteDesignation.plugins.locality,
    // Loadboard looks like it may be enabled on a person or organization level?
    loadboard: siteDesignation.plugins.loadboard,
  };
};

export default {
  assemble
};



// WEBPACK FOOTER //
// ./src/ltnplugins/EffectivePlugins.js